export enum SPACING_VARIABLES {
  APP_HEADER_HEIGHT = 50,
  MOBILE_APP_HEADER_HEIGHT = 45,
  BANNER_HEIGHT = 100
}
